export default __webpack_public_path__ + "static/media/logo_image.faca393b.svg";